import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { integrateCloverRequest } from '../../redux/slices/cloverSlice';
import { useRestaurantNav } from '../../hooks/useRestaurantNav';

// Parse OAuth parameters from URL query string
const parseOAuthParams = (search: string) => {
  const params = new URLSearchParams(search);
  return {
    merchant_id: params.get('merchant_id') || '',
    employee_id: params.get('employee_id') || '',
    client_id: params.get('client_id') || '',
    code: params.get('code') || '',
  };
};

const CloverCallback = () => {
 const { navigate } = useRestaurantNav();
  const location = useLocation();
  const dispatch = useDispatch();

  // Parse OAuth params and dispatch integration request
  useEffect(() => {
    const params = parseOAuthParams(location.search);
    
    if (params.merchant_id && params.employee_id && params.client_id && params.code) {
     
      dispatch(integrateCloverRequest({
        merchant_id: params.merchant_id,
        employee_id: params.employee_id,
        client_id: params.client_id,
        code: params.code,
      }));
    } else {
      // Missing parameters, redirect to login
      console.error('Missing OAuth parameters:', params);
      navigate('/login');
    }
  }, [location.search, dispatch, navigate]);

  // The component returns null because GlobalLoaders in AppWrapper
  // will show the appropriate loading states
  return null;
};

export default CloverCallback;
